import { useToast } from 'primevue/usetoast'

export function useNotify() {
  const toast = useToast()

  const success = (detail, summary = 'Succes') =>
    toast.add({ severity: 'success', summary, detail, life: 2500 })

  const error = (detail, summary = 'Eroare') =>
    toast.add({ severity: 'error', summary, detail, life: 3500 })

  const info = (detail, summary = 'Info') =>
    toast.add({ severity: 'info', summary, detail, life: 2500 })

  return { success, error, info }
}